export const Package = {
  essentials: 'Essentials',
  standard: 'Standard',
  premium: 'Premium',
};

export const Tiles = {
  tile1: 'essentials',
  tile2: 'standard',
  tile3: 'premium',
};

export const connection = {
  default: 1,
  min: 1,
  max: 50,
};

export const map = {
  default: 1,
  min: 1,
  max: 300,
};

export const documentK = {
  default: 4000,
  min: 4000,
  max: 100000,
};
